// extracted by mini-css-extract-plugin
export var chevron = "_r5-1";
export var clickable = "_r5-0";
export var ruleRow = "_r5-2";